var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRehostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.237,
    height: 18.082,
    viewBox: "0 0 18.237 18.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rehost_18px",
    transform: "translate(-1137.872 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rehost_18px-2",
    "data-name": "Rehost_18px",
    transform: "translate(404 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 18,
    height: 18,
    transform: "translate(734 344)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M5.4,17l1.8-1.5-1.7-2",
    transform: "translate(1137.922 384.026)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M9.5,15.5c3.6,0,6.7-1,7.6-2.3s-.2-2-2-2.7",
    transform: "translate(1137.922 384.026)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M3.1,10.3A4.2,4.2,0,0,0,.8,11.8c-.5.9,1.9,3.3,6.3,3.7",
    transform: "translate(1137.922 384.026)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone_2_",
    "data-name": "phone (2)",
    d: "M13.353,10.433v1.7a1.13,1.13,0,0,1-1.232,1.13,11.186,11.186,0,0,1-4.878-1.735A11.022,11.022,0,0,1,3.852,8.133a11.186,11.186,0,0,1-1.735-4.9A1.13,1.13,0,0,1,3.241,2h1.7a1.13,1.13,0,0,1,1.13.972,7.258,7.258,0,0,0,.4,1.588,1.13,1.13,0,0,1-.254,1.193l-.718.718A9.044,9.044,0,0,0,8.882,9.862L9.6,9.145a1.13,1.13,0,0,1,1.193-.254,7.258,7.258,0,0,0,1.588.4,1.13,1.13,0,0,1,.972,1.147Z",
    transform: "translate(1137.39 382.662)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehostIcon);
export default __webpack_public_path__ + "static/media/rehost-icon.66a136f586fa5845ba55173c5c2f640a.svg";
export { ForwardRef as ReactComponent };